/**
 * Admin Chat Oversight — view ALL conversations across the platform.
 * Admin can monitor, block/unblock users, and remove messages.
 */
import React, { useEffect } from 'react';
import { ChatInbox } from '../shared/ChatInbox';
import { useChatStore } from '../../store/chatStore';

export const AdminChatOversight: React.FC = () => {
  const {
    conversations,
    conversationsLoading,
    conversationsError,
    loadConversations,
    blockConversation,
    unblockConversation,
  } = useChatStore();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  const handleBlock = async (conversationId: string) => {
    await blockConversation(conversationId, 'Blocked by administrator');
    loadConversations(); // Refresh list
  };

  const handleUnblock = async (conversationId: string) => {
    await unblockConversation(conversationId);
    loadConversations(); // Refresh list
  };

  if (conversationsLoading && conversations.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#636E72' }}>
        Loading conversations...
      </div>
    );
  }

  if (conversationsError) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#E17055' }}>
        {conversationsError}
      </div>
    );
  }

  return (
    <ChatInbox
      conversations={conversations}
      basePath="/admin"
      title="Chat Oversight"
      subtitle="Monitor all platform conversations — block or remove non-compliant users"
      showModeration
      onBlockUser={handleBlock}
      onUnblockUser={handleUnblock}
    />
  );
};
